import React, { useEffect, useRef } from 'react';
import { RecaptchaVerifier } from 'firebase/auth';
import { auth } from '../../../auth/firebaseAuth';

const RECAPTCHA_CONTAINER_ID = 'recaptchaVerifier';

const RecaptchaVerifierView = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const verifier = new RecaptchaVerifier(
      RECAPTCHA_CONTAINER_ID,
      {
        size: 'invisible',
      },
      auth
    );
    window.recaptchaVerifier = verifier;
    verifier.render();
    const container = containerRef.current;
    return () => {
      verifier.clear();
      if (container) {
        // https://stackoverflow.com/questions/51285008/firebase-recaptchaverifier-clear-has-no-effect
        container.innerHTML = `<div id="${RECAPTCHA_CONTAINER_ID}"></div>`;
      }
    };
  }, []);

  return (
    <div ref={containerRef}>
      <div id={RECAPTCHA_CONTAINER_ID} />
    </div>
  );
};

export default RecaptchaVerifierView;
